<template>
  <div id="app">
    <rare-dashboard-header
      @emmitDownload="triggerDownload"
      @emmitLogout="triggerLogout"
    />

    <rare-control-panel v-if="showControlPanel" />

    <router-view />

    <rare-loading-overlay
      v-if="loading"
    />

    <rare-turned-off-overlay />
  </div>
</template>

<script>
import summaryPDFexportNoComp
  from './assets/exports/summaryPDFexport-NoComparison';
import summaryPDFexportOneComp
  from './assets/exports/summaryPDFexport-OneComparison';
import summaryPDFexportThreeComp
  from './assets/exports/summaryPDFexport-ThreeComparison';
import industryPDFexportNoComp
  from './assets/exports/industryPDFexport-NoComparison';
import performanceIndexPDFexportNoComparison
  from './assets/exports/performanceIndexPDFexport-NoComparison';

import dashboardHeader from './components/header/dashboardHeader.vue';
import loadingOverlay from './components/layout/RareLoadingOverlay.vue';
import RareTurnedOffOverlay from './components/layout/RareTurnedOffOverlay.vue';
import RareControlPanel from './components/controls/RareControlPanel.vue';

export default {
  name: 'App',
  components: {
    'rare-dashboard-header': dashboardHeader,
    'rare-loading-overlay': loadingOverlay,
    'rare-turned-off-overlay': RareTurnedOffOverlay,
    'rare-control-panel': RareControlPanel,
  },
  computed: {
    loading() {
      return (this.$store.getters.summaryLoadingState === 'loading' || this.$store.getters.industryLoadingState === 'loading');
    },
    showControlPanel() {
      return this.$store.getters.showControlPanel;
    },
  },
  watch: {
    $route(to) {
      this.$store.commit('updateCurrentPage', to.name);
    },
  },
  created() {
    this.$store.commit('updateLoadingModalState', true);
  },
  mounted() {
    document.title = `CRS Dashboard | ${this.$route.name}`;
    this.$store.commit('updateCurrentClient', '');
    this.$store.commit('updateCurrentColors', 'blueGrey');
    this.$store.commit('updateIndustryAverage', 0);

    const toDate = this.moment().subtract(1, 'days').format('YYYY-MM-DD');

    let fromDate;
    // Work out if today's date is before or after 1/9 and store correct start date for date picker.
    if (this.moment().unix() < this.moment(`${this.moment().format('Y')}-09-01`).unix()) {
      fromDate = this.moment(`${this.moment().subtract(1, 'year').format('Y')}-09-01`).format('YYYY-MM-DD');
    } else {
      fromDate = this.moment(`${this.moment().format('Y')}-09-01`).format('YYYY-MM-DD');
    }

    this.$store.commit('updateToDate', toDate);
    this.$store.commit('updateDefaultToDate', toDate);

    this.$store.commit('updateFromDate', fromDate);
    this.$store.commit('updateDefaultFromDate', fromDate);
  },
  methods: {
    triggerDownload() {
      if (this.$route.name === 'Summary') {
        if (this.$store.getters.industryCompAndDecimalException) {
          summaryPDFexportNoComp();
        } else if (this.$store.getters.comparisonMode === 'industry') {
          summaryPDFexportOneComp();
        } else if (this.$store.getters.comparisonMode === 'date' && this.$store.getters.comparisonYears === '1') {
          summaryPDFexportOneComp();
        } else if (this.$store.getters.comparisonMode === 'date' && this.$store.getters.comparisonYears === '3') {
          summaryPDFexportThreeComp();
        }
      } else if (this.$route.name === 'IndustryOverview') {
        if (this.$store.getters.comparisonMode === 'industry') {
          industryPDFexportNoComp('base');
        } else if (this.$store.getters.comparisonMode === 'date' && this.$store.getters.comparisonYears === '1') {
          industryPDFexportNoComp('base');
          industryPDFexportNoComp('prevYear1');
        } else if (this.$store.getters.comparisonMode === 'date' && this.$store.getters.comparisonYears === '3') {
          industryPDFexportNoComp('base');
          industryPDFexportNoComp('prevYear1');
          industryPDFexportNoComp('prevYear2');
          industryPDFexportNoComp('prevYear3');
        }
      } else if (this.$route.name === 'PerformanceIndex') {
        if (this.$store.getters.comparisonMode === 'industry') {
          performanceIndexPDFexportNoComparison('base');
        } else if (this.$store.getters.comparisonMode === 'date' && this.$store.getters.comparisonYears === '1') {
          performanceIndexPDFexportNoComparison('base');
          performanceIndexPDFexportNoComparison('prevYear1');
        } else if (this.$store.getters.comparisonMode === 'date' && this.$store.getters.comparisonYears === '3') {
          performanceIndexPDFexportNoComparison('base');
          performanceIndexPDFexportNoComparison('prevYear1');
          performanceIndexPDFexportNoComparison('prevYear2');
          performanceIndexPDFexportNoComparison('prevYear3');
        }
      }
    },
    triggerLogout() {
      this.$store.dispatch('$_login/logoutUser').then(() => {
        // Note: We're redirecting/refreshing the SPA as we want to clear
        // The store and start again when we log back in.
        window.location.replace('/login');
      });
    },
  },
};
</script>

<style lang="css">

  @import "css/app.css";

</style>
